
import { Hero } from "./hero";

const HomePage = () => {
  return <Hero />;
};

export default HomePage;
